import React, { useState } from 'react';
import useUiContext from '@groupefungo/react-apollo.core/ui/UseContext';
import HeroImage from '../../images/AMSALE_Flagship_Soho.jpg';
import WelcomeVirtualAppointments from './WelcomeVirtualAppointments';
import './App.scss';
import VirtualAppointmentForm from './VirtualAppointmentForm';
import ThankYou from './ThankYou';
import VirtualAppointmentContext from './hooks/VirtualAppointmentContext';


function VirtualAppointments() {
  const { Button } = useUiContext();
  const [step, setStep] = useState(1);

  const handleContinue = () => {
    setStep(2);
  };

  const BookingFlow = () => {
    switch (step) {
      case 1:
        return (
          <div className="appointment-select-type welcome">
            <div>
              <WelcomeVirtualAppointments/>
              <div className="button-wrapper">
                <div className="form-btn primary-btn">
                  <Button fullWidth onClick={handleContinue}>
                    Book your virtual Appointment
                  </Button>
                </div>
              </div>
            </div>
            <div className="mobile-main-image">
              <img src={HeroImage} alt="hero"/>
            </div>
          </div>
        );
        break;
      case 2:
        return (
          <div className="appointment-select-type welcome">
            <div>
              <div className="mobile-main-image">
                <img src={HeroImage} alt="hero"/>
              </div>
              <VirtualAppointmentForm/>
            </div>
          </div>
        );
        break;
      case 3:
        return (
          <div className="appointment-select-type welcome">
            <div>
              <div className="mobile-main-image">
                <img src={HeroImage} alt="hero"/>
              </div>
              <ThankYou/>
            </div>
          </div>
        );
        break;
      default:
        console.log('No case matches');
    }
    return false;
  };

  return (
    <VirtualAppointmentContext.Provider value={{ step, setStep }}>
      <BookingFlow />
    </VirtualAppointmentContext.Provider>
  );
}

export default VirtualAppointments;
